import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IScheduledPlanChange } from '@leedpulse-monorepo/interfaces';

interface ChangeSubscriptionPlanResponse {
  subscription_id: string;
  change_type?: 'upgrade' | 'downgrade'; // Applied now
  effective_date?: number; // Applied now: the day the plan switches, the next billing date for a downgrade
  scheduled_plan_change?: IScheduledPlanChange; // Set for a later day
}

/**
 * Change the plan of a number now, or schedule it for a later day.
 *
 * Applied on Stripe by the backend with the rules of the client portal. Only the plans the
 * current one leads to (`upgradable_to` / `downgradable_to`) go through.
 *
 * @param scheduledDate - YYYY-MM-DD, the day to apply it; null to apply it now
 */
async function changeSubscriptionPlan(
  subscriptionId: string,
  companyId: string,
  newPlanId: string,
  scheduledDate: string | null,
  auth: Authentication
): Promise<ChangeSubscriptionPlanResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/backoffice/change-plan',
      { subscription_id: subscriptionId, company_id: companyId, new_plan_id: newPlanId, scheduled_date: scheduledDate },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('changeSubscriptionPlan error:', e);
    throw new ChangeSubscriptionPlanFailure(e.message);
  }
}

export class ChangeSubscriptionPlanFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default changeSubscriptionPlan;